<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    id="outputOptionModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered"
      :class="{ 'xl-width': showStlPreview }"
    >
      <STLPreviewVue v-if="showStlPreview" />
      <div class="modal-content" v-else>
        <div class="modal-header">
          <h5 class="modal-title">Output Options</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="loadSTL()">
            <div class="mb-4">
              <label class="form-label" for="presicionSelect"
                >Precision: {{ precisionValue[precisionIdx] }}</label
              >
              <div class="px-5">
                <input
                  class="form-range px-1"
                  type="range"
                  min="0"
                  max="2"
                  v-model="precisionIdx"
                />
                <ul
                  class="w-100 d-flex justify-content-between p-0 m-0"
                  style="list-style-type: none; font-size: small"
                >
                  <li>low</li>
                  <li>medium</li>
                  <li>high</li>
                </ul>
              </div>
            </div>

            <div class="mb-4">
              <label class="form-label" for="presicionSelect"
                >Output Format:</label
              >
              <select
                id="presicionSelect"
                class="form-select"
                aria-label="Default select example"
                required
                v-model="isBinary"
              >
                <option :value="true">Binary</option>
                <option :value="false">ASCII</option>
              </select>
            </div>

            <div class="mb-4">
              <label class="form-label" for="presicionSelect"
                >Wall Height Settings</label
              >

              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="globalWallHeight"
                  v-model="globalWallHeight"
                  @change="() => (seperatedWallHeight = !seperatedWallHeight)"
                />
                <label class="form-check-label" for="globalWallHeight">Global</label>
              </div>
              <div class="mb-3">
                <label class="form-check-label" for="globalWallHeightValue"
                  >Global Wall Height:</label
                >
                <div class="input-group flex-nowrap">
                  <input
                    class="form-control"
                    min="0"
                    type="number"
                    id="globalWallHeightValue"
                    v-model="contentStore.chipProperties[6].value"
                    :disabled="!globalWallHeight"
                  />
                  <span class="input-group-text">µm</span>
                </div>
              </div>

              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="seperatedWallHeight"
                  v-model="seperatedWallHeight"
                  @change="() => (globalWallHeight = !globalWallHeight)"
                />
                <label class="form-check-label" for="seperatedWallHeight">Local</label>
              </div>
              <div>
              <div class="row mb-3" v-for="(pair, rowIndex) in layerPairs" :key="`row-${rowIndex}`">
                <div class="col" v-for="(layer, colIndex) in pair" :key="`col-${rowIndex}-${colIndex}`">
                  <label class="form-check-label" :for="`label${layer.id}`">{{ layer.label }}</label>
                  <div class="input-group flex-nowrap">
                    <input class="form-control" type="number" :id="`input${layer.id}`" :disabled="!seperatedWallHeight" v-model="wallHeights[(rowIndex * 2) + colIndex]" />
                    <span class="input-group-text">µm</span>
                  </div>
                </div>
                <div v-if="pair.length === 1" class="col"></div>
              </div>
            </div>
            </div>
            <hr />
            <div class="d-flex">
              <button
                type="button"
                class="btn btn-outline-secondary position-absolute"
                @click="downloadSVGZip"
              >
                Download SVG
              </button>
              <button type="submit" class="btn btn-primary m-auto">
                Generate
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useContentStore } from "@/stores/content";
import { computed, defineComponent, onMounted, ref } from "vue";
import STLPreviewVue from "./STLPreview.vue";
import JSZip from "jszip";
import { saveAs } from "file-saver";
export default defineComponent({
  components: { STLPreviewVue },
  setup() {
    const contentStore = useContentStore();
    const precisionIdx = ref(1);
    const precisionValue = ["Low", "Medium", "High"];
    const showStlPreview = ref(false);
    const isBinary = ref(true);

    const globalWallHeight = ref(true);
    const seperatedWallHeight = ref(false);


    const wallHeights = computed(() => {
      const res = [];
      for (let i = 0; i < contentStore.layers.size; i++) {
        res.push(contentStore.chipProperties[6].value);
      }
      return res;
    });

    const layers = computed(() => {
      return Array.from(contentStore.layers.values());
    });

    const layerPairs = computed(() => {
      const pairs = [];
      const layerArray = layers.value;
      for (let i = 0; i < layerArray.length; i += 2) {
        if (layerArray[i + 1] !== undefined) {
          pairs.push([layerArray[i], layerArray[i + 1]]);
        } else {
          pairs.push([layerArray[i]]);
        }
      }
      return pairs;
    });

    const loadSTL = () => {
      showStlPreview.value = true;
      contentStore.requestNewStlData(
        precisionValue[precisionIdx.value],
        isBinary.value,
        globalWallHeight.value,
        wallHeights.value
      );
    };
    const downloadSVGZip = () => {
      const zip = new JSZip();
      const color = "#0d6efd";
      const svgTag = `<svg width="${contentStore.chipLengthX / 10}" height="${
        contentStore.chipLengthY / 10
      }" viewBox="-5 -5 ${contentStore.chipLengthX + 5} ${
        contentStore.chipLengthY + 5
      }" xmlns="http://www.w3.org/2000/svg" fill="${color}" stroke="${color}">`;

      const chipBoundary = `<rect x="0" y="0" width="${contentStore.chipLengthX}" height="${contentStore.chipLengthY}" fill="none" stroke-width="10" stroke="black"/>`;
      try {
        const svgContent = document.getElementById("svgContent");
        svgContent.childNodes.forEach((layerContent) => {
          const layer = contentStore.layers.get(layerContent.id);
          if (layer) {
            const svgData = `${svgTag}${chipBoundary}${layerContent.innerHTML}</svg>`;
            zip.file(`${layer.label}_${layer.height}.svg`, svgData);
          }
        });
        zip.generateAsync({ type: "blob" }).then(function (content) {
          saveAs(content, `${contentStore.title}_svg.zip`);
        });
      } catch (err) {
        console.log(err);
      }
    };

    onMounted(() => {
      const myModalEl = document.getElementById("outputOptionModal");
      myModalEl.addEventListener("hidden.bs.modal", () => {
        showStlPreview.value = false;
      });
    });
    return {
      contentStore,
      showStlPreview,
      loadSTL,
      isBinary,
      precisionIdx,
      precisionValue,
      downloadSVGZip,
      globalWallHeight,
      seperatedWallHeight,
      layers,
      layerPairs,
      wallHeights
    };
  }
});
</script>

<style scoped>
.xl-width {
  min-width: 1100px;
}
</style>
